import Sortable from 'sortablejs';

const initializeSortable = () => {
  // OccupationSubcategoryGroupのソートを行う
  const groupList = document.querySelector('.js-groups-list');
  if (groupList && !groupList.dataset.sortableInitialized) {
    // 重複初期化を防ぐフラグを設定するのだ
    groupList.dataset.sortableInitialized = 'true';

    Sortable.create(groupList, {
      onEnd: (e) => {
        const rows = Array.from(e.target.children);
        // 表示順の列をフロント側で即時更新するのだ
        rows.forEach((row, idx) => {
          // 2番目のtdが表示順
          const orderCell = row.querySelectorAll('td')[1];
          if (orderCell) {
            orderCell.textContent = idx + 1;
          }
        });
        const groupIds = rows.map((row) => row.dataset.groupId);

        // FormDataを使ってPATCHリクエストを送信するのだ
        const formData = new FormData();
        formData.append(
          'authenticity_token',
          document.getElementsByName('csrf-token')[0].getAttribute('content'),
        );
        groupIds.forEach((id) => {
          formData.append('group_ids[]', id);
        });

        fetch('/admin/occupation_subcategory_groups/sort', {
          method: 'PATCH',
          body: formData,
        });
      },
    });
  }
};

// Turboのロードで初期化
document.addEventListener('turbo:load', initializeSortable);
